export default [
    {
        codes: [28],
        iconClass: 'pickup',
        group: 'PICKUP',
    },
    {
        codes: [32],
        iconClass: 'chassiscab',
        group: 'CHASSISCAB',
    },
    {
        codes: [15],
        iconClass: 'pickupcrewcab',
        group: 'CREWCAB',
    },
    {
        codes: [13],
        iconClass: 'pickupregularecab',
        group: 'REGULARCAB',
    },
    {
        codes: [30],
        iconClass: 'pickupdoublecab',
        group: 'DOUBLECAB',
    },
    {
        codes: [14],
        iconClass: 'pickupextendedcab',
        group: 'EXTENDEDCAB',
    },
    {
        codes: [1],
        iconClass: 'sedan',
        group: 'SEDAN',
    },
    {
        codes: [2],
        iconClass: 'coupe',
        group: 'COUPE',
    },
    {
        codes: [37],
        iconClass: 'van',
        group: 'VAN',
    },
    {
        codes: [4],
        iconClass: 'convertible',
        group: 'CONVERTIBLE',
    },
    {
        codes: [5],
        iconClass: 'wagon',
        group: 'STATION_WAGON',
    },
    {
        codes: ['LIMOUSINE'], // TO BE VALIDATED IN ES DATABASE
        iconClass: 'limousine',
        group: 'LIMOUSINE',
    },
    {
        codes: ['COMPACT'], // TO BE VALIDATED IN ES DATABASE
        iconClass: 'compact',
        group: 'COMPACT',
    },
    {
        codes: ['CARGO'], // TO BE VALIDATED IN ES DATABASE
        iconClass: 'cargo',
        group: 'CARGO',
    },
    {
        codes: ['PASSENGER'], // TO BE VALIDATED IN ES DATABASE
        iconClass: 'cargo',
        group: 'PASSENGER',
    },
    {
        codes: [26],
        iconClass: 'cargo',
        group: 'CUBE',
    },
    {
        codes: [27],
        iconClass: 'suv',
        group: 'SUV',
    },
    {
        codes: [34],
        iconClass: 'suv',
        group: 'CROSSOVER',
    },
    {
        codes: [3],
        iconClass: 'hatchback',
        group: 'HATCHBACK',
    },
    {
        codes: [7],
        iconClass: 'van',
        group: 'MINIVAN',
    },
    {
        codes: [33, -1],
        iconClass: 'sedan',
        group: 'OTHER',
    },
    {
        codes: [36],
        iconClass: 'cargo',
        group: 'CREWVAN',
    },
    {
        codes: [11],
        iconClass: 'cargo',
        group: 'CARGOVAN',
    },
    {
        codes: [35],
        iconClass: 'van',
        group: 'PASSENGERVAN',
    },
    {
        codes: [26],
        iconClass: 'boxtruck',
        group: 'BOXTRUCK',
    },
];
